import {
  withTranslation,
} from 'react-i18next';

import AdminRegattaDocumentsSectionView from './AdminRegattaDocumentsSectionView';

const TranslatedComponent = withTranslation()(AdminRegattaDocumentsSectionView);

const Component = TranslatedComponent;

export default Component;
